let yowanAuthRuntimeState = {
  authMe: null,
  accessMe: null,
  adminStatus: null,
};

export const readYowanAuthRuntimeState = () => yowanAuthRuntimeState;

export const writeYowanAuthRuntimeState = (nextState = {}) => {
  yowanAuthRuntimeState = {
    ...yowanAuthRuntimeState,
    ...nextState,
  };

  return yowanAuthRuntimeState;
};

export const clearYowanAuthRuntimeState = () => {
  yowanAuthRuntimeState = {
    authMe: null,
    accessMe: null,
    adminStatus: null,
  };

  return yowanAuthRuntimeState;
};
